/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { Button } from '@zoopla-eng/zds/button';

import { useSocialSignIn } from '../SignIn/hooks/useSocialSignIn/useSocialSignIn';
import { useSetIsLoggedIn, useUser } from '@zoopla/user';
import Preferences from '../../Preferences';
import { isNewUser } from '../../utils';
import { User } from '../../../../graphql.generated';
import { ControlledDialog } from '@zoopla-eng/zds/dialog';
import { skipLinkContainerStyle } from './index.styles.css';
import { trackGoogleOneTapClose } from './index.tracking';
import { getSegmentData } from '../../utils/getSegmentData';
import { liverampAts } from '../../utils/liverampAts';

export const GoogleTap = () => {
    const currentUserSession = useUser();
    const useLiveRampAts = true;
    const router = useRouter();
    const isGuestUser =
        currentUserSession.loggedIn === false &&
        currentUserSession.loading === false;
    const setLoggedIn = useSetIsLoggedIn();

    // Stop showing Google One Tap prompt on sign in and register pages
    const disallowList = new Set(['/signin', '/register']);
    const isInAllowList = !disallowList.has(router.pathname);

    const [showEmailPrefs, setShowEmailPrefs] = useState(false);
    const registered = currentUserSession.registered;
    const segment = getSegmentData(router.pathname);

    const signIn = () => {
        setLoggedIn(true);
    };

    const onSuccess = (user?: User) => {
        if (useLiveRampAts) {
            liverampAts(user?.email ?? '');
        }

        if (isNewUser({ registered }, user?.creationDate)) {
            localStorage.setItem('new_register_user', 'true');
            setShowEmailPrefs(true);
            return;
        }

        signIn();
    };

    const [, onSocialMediaSignIn] = useSocialSignIn({
        type: 'googleOneTap',
        actionAfterAuth: {
            eventLabel: 'google_one_tap',
            action: onSuccess
        }
    });

    const initGoogleOneTap = () => {
        onSocialMediaSignIn();
    };

    const close = () => {
        signIn();
        setShowEmailPrefs(false);
    };

    const formClosed = () => {
        trackGoogleOneTapClose();
        close();
    };

    if (showEmailPrefs) {
        return (
            <ControlledDialog
                label="Get expert advice, guidance and inspiration straight to your inbox."
                isOpen={showEmailPrefs}
                onClose={formClosed}
            >
                <Preferences
                    close={close}
                    actionAfterAuth={{
                        action: () => null,
                        eventLabel: 'google_one_tap',
                        segment
                    }}
                />
                <div className={skipLinkContainerStyle}>
                    <Button category="tertiary" onClick={formClosed}>
                        Skip and set later in Email preferences
                    </Button>
                </div>
            </ControlledDialog>
        );
    }
    return isGuestUser && isInAllowList ? (
        <>
            <style
                data-testid="google-one-tap-styles"
                dangerouslySetInnerHTML={{
                    __html: `#credential_picker_container { right: inherit !important; top: inherit !important; left: 1.5rem !important; bottom: 1.5rem !important; }`
                }}
            />
            <Script
                src="https://accounts.google.com/gsi/client"
                onLoad={initGoogleOneTap}
                data-testid="google-one-tap-script"
            />
        </>
    ) : null;
};

export default GoogleTap;
